


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import {HashRouter} from 'react-router-dom'
import Main from "./src/Main";

ReactDOM.render(
<HashRouter>
<Main />
</HashRouter>,
document.getElementById('root'))